import { all, fork } from 'redux-saga/effects';
import {
  watchUpdateLabelInstances,
  watchRemoveLabelInstance,
} from 'Modules/Shared/sagas/labels/watchers';

export default function* root() {
  yield all([fork(watchUpdateLabelInstances), fork(watchRemoveLabelInstance)]);
}
